// "Enjoying Request?" — Apple's / Google's OWN rating sheet, never one of
// ours (founder, build 38). The OS decides whether it really appears: at most
// three times a year per person on iOS, and never in TestFlight. Asked at TWO
// moments: right after the talent closes the "money is on its way" popup, and
// (1.5.1 #4) right after they mark their first real paid request as played.
//
// Static import ON PURPOSE (see appBadge.ts) — the shim is tiny and the call
// guards on isNativePlatform().
import { Capacitor } from "@capacitor/core";
import { InAppReview } from "@capacitor-community/in-app-review";

/** Never throws, never waits — a rating sheet must not hold up the money flow. */
export function askForAppRating(): void {
  if (!Capacitor.isNativePlatform()) return;
  InAppReview.requestReview().catch(() => {
    // Plugin missing in an older native build — nothing to do.
  });
}

const FIRST_PAID_PLAY_KEY = "rq_rate_first_paid_play";

/** The first-paid-play moment: once per install (this flag), and only ever
    called for a real PAID play — never a free request, never a practice card
    (Apple rejects rating asks during onboarding, so not after the demos). No
    storage → no way to keep it to once → no ask. */
export function askForAppRatingOnFirstPaidPlay(): void {
  if (!Capacitor.isNativePlatform()) return;
  try {
    if (localStorage.getItem(FIRST_PAID_PLAY_KEY)) return;
    localStorage.setItem(FIRST_PAID_PLAY_KEY, "1");
  } catch {
    return;
  }
  askForAppRating();
}
